import React , {useEffect,useState} from  'react'
import { Autocomplete, TextField} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FilterAutocomplete = ({ label , width=150  , 
   fieldName = '', 
 handleChangeSelection = () => {},
 isOptionEqualToValue = (option, value) => option.id=== value?.id,
 ...props  }) => {
    const [value, setValue] = useState(props.selectedValue);
    const [inputValue, setInputValue] = useState();

    const handleChange = (newValue) => {
        setValue(newValue?.value);
        handleChangeSelection(newValue);
      };

      useEffect(() => {
        setValue(props.selectedValue);
        setInputValue(props.selectedValue?.value);
      }, [props.selectedValue]);
  return (
    <Autocomplete
    isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => <TextField 
        label={fieldName}
        placeholder={label}
      {...params} 
      sx={{
        ".MuiFormLabel-root": { color: "#50566E" },
        "& .MuiInputBase-root": {
          backgroundColor: "#ffffff",
          borderRadius: "4px",
          color: "#1C2238",
          fontSize: ".875rem",
          fontWeight: 550,
          "& fieldset": {
            borderColor: "#D3D8E3",
          },
          "&:hover fieldset": {
            borderColor: "#D3D8E3",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#D3D8E3",
          },
          
        },
       " .MuiOutlinedInput-input":{
        '&::placeholder': {
            color: "#50566E !important",
            opacity:"1"
          }
       }
       
      }}
      size="small"
      variant="outlined"
   
      />}
      sx={{
        width: width,
      }}
      popupIcon={<ExpandMoreIcon size="small" />}
      
      {...props}
      onChange={(event, newValue) => {
        handleChange(newValue)
      }}
      disableClearable
      inputValue={inputValue || ""}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      value={value || ""}
    />
  )
}

export default FilterAutocomplete
